<wm-document-data-entity-view
  [activity]="activity"
  [application]="application"
  [entity]="entity"
  [showLabel]="showLabel"
></wm-document-data-entity-view>
